export enum FileTypes {
  identity = 'identity',
  bank = 'bank',
  shop = 'shop',
}
